class AccountDialog extends HTMLElement {
  constructor() {
    super();
    document.querySelectorAll('.no-account').forEach((button) => button.addEventListener('click', function(event){
      event.preventDefault();
      document.getElementById('gp-popup-account').setAttribute('open', '');
    }));
    this.querySelector('.mfp-close').addEventListener('click', function(){
      document.getElementById('gp-popup-account').removeAttribute('open');
    });
    this.querySelector('#RecoverPassword').addEventListener('click', function(){
      document.getElementById('FormRecoverPassword').classList.remove('hide');
      document.getElementById('FormCustomerLogin').classList.add('hide')
    });
    this.querySelector('#HideRecoverPasswordLink').addEventListener('click', function(){
      document.getElementById('FormCustomerLogin').classList.remove('hide');
      document.getElementById('FormRecoverPassword').classList.add('hide');
    });
    this.querySelector('#item-register').addEventListener('click', function(){
      document.getElementById('login_popup').classList.remove('active');
      document.getElementById('register_popup').classList.add('active');
      document.getElementById('item-login').classList.remove('active');
      document.getElementById('item-register').classList.add('active');
    });
    this.querySelector('#item-login').addEventListener('click', function(){
      document.getElementById('register_popup').classList.remove('active');
      document.getElementById('login_popup').classList.add('active');
      document.getElementById('item-register').classList.remove('active');
      document.getElementById('item-login').classList.add('active');
    });
    
    var specifiedElement = document.getElementById('close-popup-account');
    var popup = document.getElementById('gp-popup-account');

    document.addEventListener('mouseup', function(event) {
      var isClickInside = specifiedElement.contains(event.target);
      if (isClickInside == false) {
        if(popup.hasAttribute('open'))
        {
          document.getElementById('gp-popup-account').removeAttribute('open');
        }
      }
    });
    
  }
}

customElements.define("account-dialog", AccountDialog)